/**
 * Display label of an included board (meal plan) from the Player `Board.Name`,
 * e.g. "Halbpension". Returns an empty string when the Player returned no board
 * name, which is the "no included board → show nothing" case.
 *
 * A trailing code suffix such as "Halbpension [H]" is stripped defensively; the
 * Player currently sends plain names, so this is a no-op for today's data.
 */
export function boardLabel(name: string | undefined | null): string {
  return (name ?? '').replace(/\s*\[[^\]]*\]\s*$/, '').trim();
}
